import { extend, override } from "flarum/extend";
import Button from 'flarum/common/components/Button';
import Tooltip from 'flarum/common/components/Tooltip';
import NotificationList from 'flarum/forum/components/NotificationList';


app.initializers.add("lltq-unread-notifications", (app) => {
  extend(NotificationList.prototype, "controlItems", function (items) {
    items.add(
      'show_unread',
      <Tooltip text={app.translator.trans('lltq-unread-notifications.forum.show_unread_tooltip')}>
        <Button
          className={"Button Button--link" + (this.attrs.state.getParams()?.unread ? ' active' : '')}
          data-container=".NotificationList"
          icon="fas fa-list"
          title={app.translator.trans('lltq-unread-notifications.forum.show_unread_tooltip')}
          onclick={(e) => {
            this.attrs.state.refreshParams({'unread': this.attrs.state.getParams()?.unread ? 0 : 1}, 1);
            e.target?.classList?.toggle('active');
            e.stopPropagation();
          }}
        />
      </Tooltip>,
      100
    );
  });
});
